// export const MISSING = '/image-placeholder.png';
export const MISSING = '/image-placeholderu.png';
export const FIREBASESTORAGE = 'https://firebasestorage.googleapis.com/v0/b/classme-150316.appspot.com/o/videos';